import React, { useContext, useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { useIsSystemAdmin } from "../../../hooks";
import SectionSection from "../../shared/Section";
import { loadModules, setDefaultOptions } from "esri-loader";
// import Card from "../../shared/Card";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { MsalWrapperContext } from "../../../redux/actions/authActions";
import { Card, Button, Form, Row, Col } from "react-bootstrap";
import "antd/lib/button/style/index.css";
import { FormikContext, useFormik } from "formik";
import * as yup from "yup";

setDefaultOptions({ version: "4.14" });

function Profile() {
  const msalWrapper = useContext(MsalWrapperContext);
  const user = useSelector((state) => state.user);
  const history = useHistory();
  const isSystemAdmin = useIsSystemAdmin();
  const [profile, setProfile] = useState({});
  const [publicRole, setPublic] = useState(false);
  const [regulator, setRegulator] = useState();
  const [sysAdmin, setSysAdin] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [epaIds, setEpaIds] = useState([]);
  const [error, setError] = useState();
  const [facilityLayer, setFacilityLayer] = useState();
  const [view, setView] = useState();
  const [webMap, setWebMap] = useState();
  const mapRef = useRef();
  const [edit, setEdit] = useState(false);
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "EpaId",
      field: "EpaId",
    },
    {
      headerName: "FacName",
      field: "FacName",
    },
    {
      headerName: "FacStr",
      field: "FacStr1",
    },
    {
      headerName: "FacCity",
      field: "FacCity",
    },
    // {
    //     headerName: "FacZip",
    //     field: "FacZip"
    // },
    {
      headerName: "ContactName",
      field: "ContactName",
    },
    {
      headerName: "ContactEmail",
      field: "ContactEmail",
    },
    // {
    //     headerName: "OwnerName",
    //     field: "OwnerName"
    // },
  ]);

  const phoneRegExp = /\d{10}$/;

  const schema = yup.object({
    CompanyName: yup
      .string()
      .nullable()
      .max(70, "Must be 70 characters or less.")
      .required("Organization is required."),
    Title: yup
      .string()
      .nullable()
      .min(1, "test")
      .max(80, "Must be 80 characters or less.")
      .required("Title is required."),
    Str1: yup
      .string()
      .nullable()
      .max(35, "Must be 35 characters or less.")
      .required("Address is required."),
    Str2: yup.string().nullable().max(35, "Must be 35 characters or less."),
    Phone: yup
      .string()
      .nullable()
      .min(10, "Must be at least 10 digits.")
      .max(10, "Must be 10 digits or fewer.")
      .matches(phoneRegExp, "Phone number is not valid")
      .required("Phone Number is required."),
    Ext: yup.string().nullable().max(6, "Must be 6 digits or less."),
    Fax: yup
      .string()
      .nullable()
      .min(10, "Must be 10 digits.")
      .max(10, "Must be 10 digits.")
      .matches(phoneRegExp, "Phone number is not valid"),
    City: yup
      .string()
      .nullable()
      .max(20, "Must be 20 characters or less.")
      .required("City is required."),
    St: yup
      .string()
      .nullable()
      .max(2, "Must be 2 characters or less.")
      .required("State is required."),
    Zip: yup
      .string()
      .nullable()
      .max(9, "Must be 9 characters or less.")
      .required("Zip Code is required."),
  });

  const getProfile = async () => {
    await axios.get("api/v1/hwts/user/profile").then((res) => {
      setProfile(res.data);
    });
  };

  const onEditClick = () => {
    setEdit(true);
  };

  const roles = user.roles.map((role, i) => <p key={i}>{role}</p>);

  const isPublic = async () => {
    await axios.get("api/v1/hwts/role/check/public").then((res) => {
      setPublic(JSON.stringify(res.data));
    });
  };

  const isRegulator = async () => {
    await axios.get("api/v1/hwts/role/check/regulator").then((res) => {
      setRegulator(JSON.stringify(res.data));
    });
  };

  const systemAdmin = async () => {
    await axios.get("api/v1/hwts/role/check/sysadmin").then((res) => {
      setSysAdin(JSON.stringify(res.data));
    });
  };

  const getEpaIds = async () => {
    setIsFetching(true);
    axios
      .get(`api/v1/hwts/tempid/handler/email?Email=STAN.OSHITA%40DOT.CA.GOV`)
      .then((results) => {
        setEpaIds(results.data);
        setIsFetching(false);
        //if (this.state.map) this.createFacilities();
      })
      .catch((error) => {
        setError(error.response);
        setIsFetching(false);
      });
  };
  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (epaIds.length < 1) getEpaIds();
    if (epaIds.length > 0 && !webMap) createMap();
    if (webMap && !view) createView();
    if (epaIds.length > 0 && !facilityLayer && webMap && view)
      createFacilities();
    if (facilityLayer && webMap && view) webMap.add(facilityLayer);
  }, [user, epaIds, webMap, view, facilityLayer]);

  const onGridReady = async (params) => {
    var gridApi = params.api;
    var gridColumnApi = params.columnApi;

    sizeToFit(gridApi);
    onBtHide(gridApi);
  };

  const sizeToFit = async (gridApi) => {
    gridApi.sizeColumnsToFit();
  };

  const autoSizeAll = async (gridColumnApi) => {
    var allColumnIds = [];
    gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    gridColumnApi.autoSizeColumns(allColumnIds);
  };

  const onBtExport = async (gridApi) => {
    //e.preventDefault();
    var params = {};
    gridApi.exportDataAsCsv(params);
  };

  const onBtShowLoading = async (gridApi) => {
    gridApi.showLoadingOverlay();
  };

  const onBtShowNoRows = async (gridApi) => {
    gridApi.showNoRowsOverlay();
  };

  const onBtHide = async (gridApi) => {
    gridApi.hideOverlay();
  };

  const showColumn = async (gridColumnApi, column, show) => {
    gridColumnApi.setColumnVisible(column, show);
  };

  const createFacilities = async () => {
    loadModules([
      "esri/layers/FeatureLayer",
      "esri/layers/support/Field",
      "esri/widgets/Expand",
      "esri/widgets/Search",
      "esri/tasks/Locator",
      "esri/layers/TileLayer",
    ])
      .then(([FeatureLayer, Field, Expand, Search, Locator, TileLayer]) => {
        const facilityRenderer = {
          type: "simple",
          symbol: {
            type: "simple-marker",
            size: 10,
            //color:[0, 255, 255],
            color: [255, 0, 0],
            //outline: null,
          },
        };

        const fields = [
          new Field({
            name: "ObjectID",
            alias: "ObjectID",
            type: "oid",
          }),
          new Field({
            name: "FacName",
            alias: "FacName",
            type: "string",
          }),
          new Field({
            name: "EpaId",
            alias: "EpaId",
            type: "string",
          }),
        ];

        const facilities = epaIds.map((data, idx) => {
          return {
            geometry: {
              type: "point",
              x: data.DdLongitude,
              y: data.DdLatitude,
            },
            attributes: {
              ObjectID: idx,
              FacName: data.FacName,
              EpaId: data.EpaId,
            },
          };
        });

        var facilitiesPopup = {
          title: "<b>({EpaId}) - {FacName}</b>",
          // "content": "<b>{FacName}</b>"
        };

        const facilityLayer = new FeatureLayer({
          title: "facility layer",
          source: facilities,
          fields: fields,
          ObjectIDField: "ObjectID",
          renderer: facilityRenderer,
          popupTemplate: facilitiesPopup,
        });

        facilityLayer.on("layerview-create", (e) => {
          facilityLayer.queryExtent().then((response) => {
            if (response.count === 1) {
              view.goTo({
                target: facilities[0],
                zoom: 20,
              });
            } else {
              view.goTo(response.extent.expand(1.3));
            }
          });
        });

        setFacilityLayer(facilityLayer);
      })
      .catch((err) => console.error(err));
  };

  const createMap = async () => {
    loadModules(["esri/WebMap", "esri/Basemap"], { css: true }).then(
      ([WebMap, Basemap]) => {
        const map = new WebMap({
          basemap: Basemap.fromId("streets-vector"),
        });
        setWebMap(map);
      }
    );
  };

  const createView = async () => {
    loadModules(
      [
        "esri/WebMap",
        "esri/views/MapView",
        "esri/views/SceneView",
        "esri/Basemap",
        "esri/layers/FeatureLayer",
        "esri/renderers/DotDensityRenderer",
        "esri/widgets/Legend",
        "esri/webmap/Bookmark",
        "esri/widgets/Bookmarks",
        "esri/widgets/Expand",
        "esri/widgets/LayerList",
        "esri/widgets/Slider",
        "esri/widgets/ScaleBar",
        "esri/geometry/Extent",
        "esri/widgets/Locate",
      ],
      { css: true }
    ).then(
      ([
        WebMap,
        MapView,
        SceneView,
        Basemap,
        FeatureLayer,
        DotDensityRenderer,
        Legend,
        Bookmark,
        Bookmarks,
        Expand,
        LayerList,
        Slider,
        ScaleBar,
        Extent,
        Locate,
      ]) => {
        var view = new MapView({
          container: mapRef.current,
          map: webMap,
          //center: [-122.057281, 38.250313],
          //center: [-122.057281, 38.250313],
          zoom: 8,
          highlightOptions: {
            fillOpacity: 5,
            color: [0, 153, 0, 1],
            haloColor: [0, 153, 0, 1],
          },
          popup: {
            dockEnabled: true,
            dockOptions: {
              position: "top-right",
              breakpoint: false,
            },
          },
          constraints: {
            maxScale: 35000,
            minScale: 10000000,
          },
        });

        var locate = new Locate({
          view: view,
        });

        view.ui.add(locate, "top-left");
        setView(view);
      }
    );
  };

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const formatZipCode = (zipcode) => {
    return zipcode.slice(0, 5);
  };

  const handleReset = () => {
    setEdit(false);
  };

  const formik = useFormik({
    initialValues: profile,
    validationSchema: schema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      let newObj = {};
      Object.keys(values).map((a, i) => {
        newObj[a] = values[a];
      });
      await axios
        .put(
          `api/v1/hwts/user/maintenance/users/${formik.initialValues.UserId}`,
          newObj
        )
        .then((res) => {
          setEdit(false);
        });
    },
  });

  const form1Config = [
    //  {label: "User ID",name: "UserId"},
    { label: "First Name", name: "FirstName" },
    { label: "Last Name", name: "LastName" },
    { label: "Email", name: "Email" },
  ];
  const form2Config = [
    { label: "Organization", name: "CompanyName" },
    { label: "Title", name: "Title" },
  ];
  const form3Config = [
    { label: "Phone", name: "Phone" },
    { label: "Ext.", name: "Ext" },
    { label: "Fax", name: "Fax" },
  ];
  const form4Config = [{ label: "Address", name: "Str1" }];
  const form5Config = [{ label: "Address 2", name: "Str2" }];
  const form6Config = [
    { label: "City", name: "City" },
    { label: "State", name: "St" },
    { label: "Zip Code", name: "Zip" },
  ];

  return (
    <div>
      <SectionSection title={"Profile"} type={"standout"} />
      <div className="container profile-container">
        <ol className="breadcrumb">
          <li>
            <Link to="/" title="Home">
              Home
            </Link>
          </li>
          <li className="active">Profile</li>
        </ol>
        {profile.Email ? (
          <div style={{ width: "100%", margin: "auto" }} className="">
            <form onSubmit={formik.handleSubmit} onReset={handleReset}>
              <Card>
                <Card.Header>
                  <div>
                    <span>Account Information</span>

                    {edit == false ? (
                      <span style={{ float: "right" }}>
                        <Button
                          onClick={() => onEditClick()}
                          type="primary"
                          shape="round"
                        >
                          Edit Profile
                        </Button>
                        <span> </span>
                        {edit == false ? (
                        <Button
                          onClick={() => msalWrapper.onResetPassword()}
                          type="primary"
                          shape="round"
                        >
                          Change Password
                        </Button> 
                        ) : ( null )}
                      </span>
                    ) : (
                      <span style={{ float: "right" }}>
                        <div>
                          <Button variant="success" type="danger">
                            Submit
                          </Button>
                          <span> </span>
                          <Button
                            onClick={formik.resetForm}
                            variant="danger"
                            type="reset"
                          >
                            Cancel
                          </Button>
                        </div>
                      </span>
                    )}
                  </div>
                </Card.Header>
                <Card.Body>
                  <Form.Row>
                    {form1Config.map((input, index) => (
                      <Form.Group as={Col} controlId={input.name}>
                        <Form.Label>{input.label}</Form.Label>
                        <Form.Control
                          size="sm"
                          disabled={true}
                          type="text"
                          onChange={formik.handleChange}
                          defaultValue={formik.initialValues[input.name]}
                          placeholder=""
                          isInvalid={formik.errors[input.name]}
                        />
                      </Form.Group>
                    ))}
                  </Form.Row>

                  <Form.Row>
                    {form2Config.map((input, index) => (
                      <Form.Group as={Col} controlId={input.name}>
                        <Form.Label>
                          {input.label}
                          <span className="ml-1" style={{ color: "red" }}>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          disabled={!edit}
                          type="text"
                          onChange={formik.handleChange}
                          defaultValue={formik.initialValues[input.name]}
                          placeholder=""
                          isInvalid={formik.errors[input.name]}
                        />
                        {formik.touched[input.name] &&
                        formik.errors[input.name] ? (
                          <span
                            className="ml-1"
                            size="sm"
                            style={{ color: "red" }}
                          >
                            {formik.errors[input.name]}
                          </span>
                        ) : null}
                      </Form.Group>
                    ))}
                  </Form.Row>
                  <Form.Row>
                    {form3Config.map((input, index) => (
                      <Form.Group as={Col} controlId={input.name}>
                        <Form.Label>
                          {input.label}
                          {input.label !== "Phone" ? (
                            ""
                          ) : (
                            <span className="ml-1" style={{ color: "red" }}>
                              *
                            </span>
                          )}
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          disabled={!edit}
                          type="text"
                          onChange={formik.handleChange}
                          defaultValue={formik.initialValues[input.name]}
                          placeholder=""
                          isInvalid={formik.errors[input.name]}
                        />
                        {formik.touched[input.name] &&
                        formik.errors[input.name] ? (
                          <span
                            className="ml-1"
                            size="sm"
                            style={{ color: "red" }}
                          >
                            {formik.errors[input.name]}
                          </span>
                        ) : null}
                      </Form.Group>
                    ))}
                  </Form.Row>
                  <Form.Row>
                    {form4Config.map((input, index) => (
                      <Form.Group as={Col} controlId={input.name}>
                        <Form.Label>
                          {input.label}
                          <span className="ml-1" style={{ color: "red" }}>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          disabled={!edit}
                          type="text"
                          onChange={formik.handleChange}
                          defaultValue={formik.initialValues[input.name]}
                          placeholder=""
                          isInvalid={formik.errors[input.name]}
                        />
                        {formik.touched[input.name] &&
                        formik.errors[input.name] ? (
                          <span
                            className="ml-1"
                            size="sm"
                            style={{ color: "red" }}
                          >
                            {formik.errors[input.name]}
                          </span>
                        ) : null}
                      </Form.Group>
                    ))}
                  </Form.Row>

                  <Form.Row>
                    {form5Config.map((input, index) => (
                      <Form.Group as={Col} controlId={input.name}>
                        <Form.Label>{input.label}</Form.Label>
                        <Form.Control
                          size="sm"
                          disabled={!edit}
                          type="text"
                          onChange={formik.handleChange}
                          defaultValue={formik.initialValues[input.name]}
                          placeholder=""
                          isInvalid={formik.errors[input.name]}
                        />
                        {formik.touched[input.name] &&
                        formik.errors[input.name] ? (
                          <span
                            className="ml-1"
                            size="sm"
                            style={{ color: "red" }}
                          >
                            {formik.errors[input.name]}
                          </span>
                        ) : null}
                      </Form.Group>
                    ))}
                  </Form.Row>

                  <Form.Row>
                    {form6Config.map((input, index) => (
                      <Form.Group as={Col} controlId={input.name}>
                        <Form.Label>
                          {input.label}
                          <span className="ml-1" style={{ color: "red" }}>
                            *
                          </span>
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          disabled={!edit}
                          type="text"
                          onChange={formik.handleChange}
                          defaultValue={formik.initialValues[input.name]}
                          placeholder=""
                          isInvalid={formik.errors[input.name]}
                        />
                        {formik.touched[input.name] &&
                        formik.errors[input.name] ? (
                          <span
                            className="ml-1"
                            size="sm"
                            style={{ color: "red" }}
                          >
                            {formik.errors[input.name]}
                          </span>
                        ) : null}
                      </Form.Group>
                    ))}
                  </Form.Row>
                  {edit ? (
                    <span className="font-italic" size="sm">
                      {" "}
                      * Contact HWTS Administration for Name or Email changes.{" "}
                    </span>
                  ) : null}
                </Card.Body>
              </Card>
            </form>
          </div>
        ) : null}
        {isSystemAdmin && epaIds.length > 0 ? (
          <Card>
            <Card.Header>
              <div>
                <span>EPAIDs Associated to this Profile</span>

                {/* <span style={{ float: "right" }}>
                  <Link to={"/tempid"}>
                    <Button type="primary" shape="round">
                      Apply for New Temporary EPAID
                    </Button>
                  </Link>
                </span> */}
              </div>
            </Card.Header>
            <Card.Body>
              <div>
                <div
                  className=""
                  style={{ position: "relative", height: "300px" }}
                >
                  <div
                    className="webmap-full"
                    ref={mapRef}
                    style={{ height: "100%" }}
                  />
                </div>
                <div
                  className="ag-theme-balham m-b-md m-t-md"
                  style={{ height: "100%", width: "100%" }}
                >
                  <div>
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={epaIds && epaIds.length > 0 ? epaIds : []}
                      onGridReady={onGridReady}
                      enableCellTextSelection={true}
                      pagination={true}
                      //paginationPageSize={this.state.paginationPageSize}
                      domLayout="autoHeight"
                      //overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                      // overlayNoRowsTemplate={
                      //   this.state.overlayNoRecordsTemplate
                      // }
                    />
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        ) : null}
      </div>
    </div>
  );
}

export default Profile;
